// @flow
import Immutable from "seamless-immutable";

export default () => Immutable({
	__record: "QueueRecord",
});
